/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
App.ready(() => App.search.init_ajaxy_search());

App.search = {
  init_ajaxy_search() {
    this.timer = null;
    $(document)
      .off("keyup", ".js-search-filter>input", App.search.ajax_search_timer)
      .on("keyup", ".js-search-filter>input", App.search.ajax_search_timer);
    $(document)
      .off("submit", ".js-search-filter", App.search.submit_ajax_search)
      .on("submit", ".js-search-filter", App.search.submit_ajax_search);
    $(document)
      .off("click", ".js-search-reset", App.search.reset)
      .on("click", ".js-search-reset", App.search.reset);

    return this.toggle_reset(".js-search-filter");
  },

  ajax_search_timer(e) {
    if (e.which !== 13) {
      if (App.search.timer) {
        clearTimeout(App.search.timer);
      }

      const input = this;
      return App.search.timer = setTimeout((() => App.search.send_ajax_search(input)), 500);
    }
  },

  send_ajax_search(input) {
    const params = { q: $(input).val() };
    if (window.location.search.match(/scheduled=1/)) {
      params.scheduled = 1;
    }

    $.get(window.location.href, params, null, "script" );

    if (App.search.timer) {
      return clearTimeout(App.search.timer);
    }
  },

  submit_ajax_search(e) {
    e.preventDefault();
    clearTimeout(App.search.timer);
    return App.search.send_ajax_search($(this).find("input"));
  },

  toggle_reset(form) {
    const $form = $(form);
    if (!$form.length) { return; }

    const val = $form.find("input").val().trim();

    if (val.length > 0) {
      return $form.addClass("active");
    } else {
      return $form.removeClass("active");
    }
  },

  reset(evt) {
    const $form = $(this).closest("form");
    $form.find("input").val("");
    return $form.submit();
  }
};
